import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { connect } from "react-redux";
import { UserActionTypes } from "../../../../store/actions/types";
import { RootState } from "../../../../store";
import { selectUserSlice, selectUserValue } from "../../../../selectors";
import { registerPatch } from "../../../../store/actions/userActions";

const mapper = (dispatch: ThunkDispatch<any, any, AnyAction>) => ({
  submit: (
    username: string,
    givenName: string,
    familyName: string,
    email: string,
    password: string,
    passwordRepeat: string,
    tel: string,
    newsletter: boolean,
    reCaptchaToken: string
  ) => {
    registerPatch(
      dispatch,
      username,
      givenName,
      familyName,
      email,
      password,
      passwordRepeat,
      tel,
      newsletter,
      reCaptchaToken
    );
  },
  reset: () => {
    dispatch({ type: UserActionTypes.RESET_FORM });
  },
});

const props = (state: RootState) => ({
  user: selectUserValue(state),
  registerStatus: selectUserSlice(state).registerStatus,
});

export const connector = connect(props, mapper);
